<template>
  <component
    :is="component.type"
    v-bind="$path('component.props', source) ? source.component.props : {}"
    class="widget-section"
    v-if="description"
  >
    <div v-if="hasBorder" class="widget-section__border"></div>
    <section class="widget-section-content">
      <div v-auto-animate>
        <header>
          <component :is="titleTag" v-if="title" class="widget-section-content__title">{{ title.label }}</component>
          <p v-if="description" class="widget-section-content__description">
            {{ description }}
          </p>
          <button v-if="!showInitalDetails && chartData" @click="handleShow()">
            {{ show ? $t('hideDetails') : $t('readMore') }}
          </button>
        </header>
        <section v-if="showInitalDetails || show" class="widget-section-content__disclaimer">
          <ul
            v-for="(item, index) in chartData"
            :key="index"
            v-auto-animate
            class="widget-section-content__disclaimer-overview"
          >
            <li>
              <span>({{ item.count }})</span>
              <span>{{ item.label }}</span>
              <button @click="handleToggle(index)">
                {{
                  showMore === index
                    ? `${$t('hide')} ${$tc('unit', 2).toLowerCase()}`
                    : `${$t('show')} ${$tc('unit', 2).toLowerCase()}`
                }}
              </button>
            </li>
            <li v-auto-animate>
              <ul class="widget-section-content__disclaimer-details" v-if="showMore === index">
                <li v-for="doc in item.items" :key="doc._id">
                  <router-link :to="{ name: 'residential-edit', params: { id: doc.id } }">{{
                    doc.displayName || doc.number
                  }}</router-link>
                </li>
              </ul>
            </li>
          </ul>
        </section>
      </div>
    </section>
  </component>
</template>

<script>
import { AlertComponent as Alert } from 'vue-elder-alert'

export default {
  data() {
    return {
      show: false,
      showMore: -1,
    }
  },
  props: {
    data: Object,
    source: Object,
  },
  computed: {
    showInitalDetails() {
      return this.chartData && this.chartData.length < 5
    },
    chartData() {
      if (!this.source || !this.data) return
      return typeof this.source.data === 'function'
        ? this.source.data({ data: this.data, source: this.source, colors: this.colors })
        : this.source.data
    },
    title() {
      if (!this.source || !this.source.title) return
      return typeof this.source.title === 'function'
        ? this.source.title({ data: this.data, source: this.source })
        : this.source.title
    },
    titleTag() {
      if (!this.source.title || !this.source.title.tag) return 'h2'
      return this.source.title.tag
    },
    description() {
      if (!this.data) return
      if (this.data.data.length === 0 && this.data.residentials && this.data.residentials.length === 0)
        return this.$t('projectStatisticsEmpty')
      if (this.data.data.length === 0 || !this.source || !this.source.description) return
      return typeof this.source.description === 'function'
        ? this.source.description({ data: this.data, source: this.source })
        : this.source.description
    },
    hasBorder() {
      return this.source.border
    },
    component() {
      if (!this.source || !this.source.component) return { type: 'Alert', props: { theme: 'primary' } }
      return this.source.component
    },
  },
  methods: {
    handleToggle(index) {
      if (index === this.showMore) {
        index = -1
      }
      this.showMore = index
    },
    handleShow() {
      this.show = !this.show
    },
  },
  components: {
    Alert,
  },
}
</script>

<style lang="scss">
.widget-section {
  flex-grow: 1;
  width: 100%;
  position: relative;

  ul,
  li {
    position: relative;
  }

  header {
    position: relative;

    button {
      margin-top: 0.5rem;
      border-bottom: 1px solid #333;
      cursor: pointer;
    }
  }

  &__border {
    display: block;
    margin: 1rem 0;
    height: 1px;
    background-color: #aeb2b6;
  }

  &-content {
    position: relative;
    display: flex;
    justify-content: space-between;
    align-items: center;

    &__title {
      font-weight: 700;
      font-size: 1.4rem;
      margin: 0;
    }

    &__description {
      font-weight: 400;
      font-size: 1rem;
      margin: 0;
      margin-top: 1rem;
    }

    &__disclaimer {
      position: relative;

      button {
        border-bottom: 1px solid #333;
        max-width: max-content;
        width: 100%;
        cursor: pointer;
      }

      &-overview {
        padding: 0;

        & > li {
          display: flex;
          gap: 0.3rem;
        }
      }
      &-details {
        li {
          a {
            border-bottom: 1px solid var(--primary);
          }
        }
      }
    }
    &__actions {
      ul {
        margin: 0;
        list-style: none;
      }
    }
  }
}
</style>
